/**
 * Report Generator — the Studio shell.
 *
 * The Classic two-pane page (config rail + tabbed preview) was retired on
 * 2026-07-22 alongside the Minutes Classic view. ReportStudio is now the only
 * shell: it owns the deterministic live document, the annexure tab strip, the
 * full config form (Details overlay), AI Polish, inline editing, export and
 * saved-draft restore — plus the copilot dock and the server-synced draft.
 */
import AppLayout from '../components/layout/AppLayout';
import ReportStudio from '../components/report/ReportStudio';

export default function ReportGeneratorPage() {
  return (
    <AppLayout pageTitle="Report Studio" fullHeight>
      <ReportStudio />
    </AppLayout>
  );
}
